import { LturRouter, SearchMaskInputType, store, websiteActions, ProductTypeHelper } from 'ltur-state-engine';
import { default as Products } from './Products';
var UrlHelper = /** @class */ (function () {
    function UrlHelper() {
    }
    UrlHelper.updateBrowserUrl = function (lturState, replaceState, forceDefaultPagination, resetStateParams) {
        if (replaceState === void 0) { replaceState = false; }
        if (forceDefaultPagination === void 0) { forceDefaultPagination = false; }
        if (resetStateParams === void 0) { resetStateParams = true; }
        var productType = lturState.websiteState.app.url.context.productType;
        var searchMaskGroupType = ProductTypeHelper.mapToSearchMaskGroupType(productType);
        var url = LturRouter.generate(lturState, searchMaskGroupType, null, forceDefaultPagination, false, false, resetStateParams, true);
        if (history.pushState && history.replaceState) {
            if (replaceState) {
                window.history.replaceState("", "", url);
            }
            else {
                window.history.pushState("", "", url);
            }
            var thunkDispatch = store.dispatch;
            thunkDispatch(websiteActions.setLocation(window.location));
            thunkDispatch(websiteActions.setUrlContext(window.location));
            thunkDispatch(websiteActions.setUrlQuery(window.location));
        }
        else {
            // Decided to reload page if history.pushState / history.replaceState is not supported by browser
            document.location.href = url;
        }
    };
    UrlHelper.createUrl = function (lturState, searchMaskGroupType, flatPackageProductGroup, forceDefaultPagination, forceDefaultSorting, resetHiddenFilters) {
        var searchMaskGroup = JSON.parse(JSON.stringify(lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType]));
        searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].confirmedValue.value =
            Products.createDestinationConfirmedValue(flatPackageProductGroup);
        searchMaskGroup.inputs[SearchMaskInputType.DESTINATION].coreQuery =
            Products.createDestinationCoreQuery(flatPackageProductGroup);
        var searchMaskInput = JSON.parse(JSON.stringify(searchMaskGroup.inputs[SearchMaskInputType.DESTINATION]));
        return LturRouter.generate(lturState, searchMaskGroupType, [searchMaskInput], forceDefaultPagination, forceDefaultSorting, resetHiddenFilters, true, false);
    };
    return UrlHelper;
}());
export default UrlHelper;
